<template>
    <b-modal v-model="localShow" centered size="xl" hide-footer hide-header>
        <b-row align-h="between">
            <b-col class="pt-3 pl-4" align-self="end" cols="11">
                <span class="title">
                    {{ $t('moodPulse.modal.title') }}
                </span>
            </b-col>
            <b-col align-self="start" cols="1">
                <img @click="localShow = false" class="close" src="@/assets/images/mood-pulse/close.svg" />
            </b-col>
        </b-row>
        <b-row>
            <b-col class="pt-4 pl-4 pr-4" cols="12">
                <label class="label-text" for="name">{{ $t('moodPulse.modal.questionName') }} </label>
                <b-form-input
                    id="name"
                    :placeholder="$t('moodPulse.modal.placeholderName')"
                    v-model="form.question"
                    type="text"
                />
            </b-col>
            <b-col class="pt-4 pl-4 pr-4" cols="12">
                <label class="label-text" for="week">{{ $t('moodPulse.modal.questionDays') }}</label>
                <b-row class="pl-3">
                    <b-form-checkbox-group
                        id="week"
                        v-model="daysSelected"
                        :options="weekOptions"
                        buttons
                        button-variant="outline-primary"
                    />
                </b-row>
            </b-col>
            <b-col class="pt-4 pl-4 pr-4" cols="12">
                <label class="label-text" for="who">{{ $t('moodPulse.modal.questionWho') }} </label>
                <departments
                    class="mb-0"
                    :value.sync="form.sections"
                    enableSelectAll
                    :placeholder="$t('moodPulse.modal.placeholderWho')"
                />
            </b-col>
            <b-col class="pt-4 pl-4 pr-4" cols="12">
                <label class="label-text" for="comment">{{ $t('moodPulse.modal.questionComment') }} </label>
                <b-row class="pl-3">
                    <b-form-checkbox class="mr-4" v-model="form.can_comment">
                        <p class="placeholder-text">
                            {{ $t('moodPulse.modal.enableComment') }}
                        </p>
                    </b-form-checkbox>
                    <b-form-checkbox v-model="form.must_comment">
                        <p class="placeholder-text">
                            {{ $t('moodPulse.modal.mandatoryComment') }}
                        </p>
                    </b-form-checkbox>
                </b-row>
            </b-col>
            <b-col class="pt-4 pl-4 pr-4" cols="12">
                <label class="label-text">{{ $t('moodPulse.modal.questionAnonymus') }} </label>
                <b-form-checkbox class="mr-4" v-model="form.can_anonymous">
                    <span class="placeholder-text">
                        {{ $t('moodPulse.modal.enableAnonymus') }}
                    </span>
                </b-form-checkbox>
            </b-col>
            <b-col class="pt-4 pl-4 pr-4" cols="12">
                <label class="label-text">{{ $t('moodPulse.modal.questionFrequency') }} </label>
                <b-form-radio-group
                    class="placeholder-text"
                    v-model="form.quiz_email_frequency_id"
                    :options="emailOptions"
                />
            </b-col>
            <b-col class="pt-3 pl-4 pr-4" cols="12">
                <span style="font-style: italic" class="placeholder-text">
                    {{ $t('moodPulse.modal.sendInfo') }}
                </span>
            </b-col>
        </b-row>
        <b-row class="pb-3" align-h="end">
            <b-col cols="3">
                <b-button
                    id="btn-humor-save-survey"
                    :disabled="disableSave"
                    @click="saveQuiz(false)"
                    class="mr-1"
                    variant="outline-primary"
                >
                    {{ $t('modal.save') }}
                </b-button>
                <b-button
                    id="btn-humor-save-and-start-survey"
                    :disabled="disableSave"
                    @click="saveQuiz(true)"
                    variant="primary"
                    class="ml-2"
                >
                    {{ $t('moodPulse.modal.saveAndStart') }}
                </b-button>
            </b-col>
        </b-row>
    </b-modal>
</template>

<script>
import { createQuiz, updateQuiz } from '../api'
import { Departments } from '@/views/components/fields'
import notification, { success, danger } from '@/lib/notification'

notification.init()

export default {
    props: {
        name: 'NNewQuestionModal',
        show: {
            required: true,
            type: Boolean,
        },
        refreshItems: {
            required: true,
            type: Function,
        },
        itemToEdit: {
            required: false,
            type: Object,
        },
    },
    components: {
        Departments,
    },
    watch: {
        itemToEdit() {
            this.form = {
                question: null,
                sunday: false,
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                can_anonymous: false,
                can_comment: false,
                must_comment: false,
                quiz_email_frequency_id: 1,
                start_now: false,
                sections: [],
            }
            this.daysSelected = []

            if (this.itemToEdit) {
                this.form.question = this.itemToEdit.quiz_question[0].question
                this.form.can_anonymous = !!this.itemToEdit.can_anonymous
                this.form.can_comment = !!this.itemToEdit.can_comment
                this.form.must_comment = !!this.itemToEdit.must_comment
                this.form.quiz_email_frequency_id = this.itemToEdit.quiz_email_frequency_id
                this.form.start_now = false
                this.form.sections = this.itemToEdit.sections.map((section) => ({
                    value: section.id,
                    label: section.name,
                    section,
                }))

                if (this.itemToEdit.monday) this.daysSelected.push('monday')
                if (this.itemToEdit.tuesday) this.daysSelected.push('tuesday')
                if (this.itemToEdit.wednesday) this.daysSelected.push('wednesday')
                if (this.itemToEdit.thursday) this.daysSelected.push('thursday')
                if (this.itemToEdit.friday) this.daysSelected.push('friday')
                if (this.itemToEdit.saturday) this.daysSelected.push('saturday')
                if (this.itemToEdit.sunday) this.daysSelected.push('sunday')
            }
        },
    },
    computed: {
        localShow: {
            get() {
                return this.show
            },
            set(localShow) {
                this.$emit('click', localShow)
            },
        },
        disableSave() {
            return !this.form.sections.length || !this.form.question || !this.daysSelected.length
        },
    },
    data() {
        return {
            form: {
                question: this.$t('moodPulse.modal.placeholderName'),
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                sunday: false,
                can_anonymous: false,
                can_comment: false,
                must_comment: false,
                quiz_email_frequency_id: 1,
                start_now: false,
                sections: [],
            },
            weekOptions: [
                {
                    text: this.$t('moodPulse.modal.sunday'),
                    value: 'sunday',
                },
                {
                    text: this.$t('moodPulse.modal.monday'),
                    value: 'monday',
                },
                {
                    text: this.$t('moodPulse.modal.tuesday'),
                    value: 'tuesday',
                },
                {
                    text: this.$t('moodPulse.modal.wednesday'),
                    value: 'wednesday',
                },
                {
                    text: this.$t('moodPulse.modal.thursday'),
                    value: 'thursday',
                },
                {
                    text: this.$t('moodPulse.modal.friday'),
                    value: 'friday',
                },
                {
                    text: this.$t('moodPulse.modal.saturday'),
                    value: 'saturday',
                },
            ],
            daysSelected: [],
            emailOptions: [
                {
                    text: this.$t('moodPulse.modal.allSelectedDays'),
                    value: 1,
                },
                {
                    text: this.$t('moodPulse.modal.oneTimePerWeek'),
                    value: 2,
                },
                {
                    text: this.$t('moodPulse.modal.startedResearch'),
                    value: 3,
                },
                {
                    text: this.$t('moodPulse.modal.dontSend'),
                    value: 4,
                },
            ],
        }
    },
    methods: {
        saveQuiz(start = false) {
            this.form.start_now = !!start
            this.daysSelected.forEach((day) => (this.form[day] = true))

            let sections = this.form.sections.filter((section) => section !== undefined)
            this.form.sections = sections.map((section) => section && section.value)

            if (this.itemToEdit) this.updateNew(this.form)
            else this.createNew(this.form)
        },
        createNew(form) {
            createQuiz(form)
                .then(() => success(this.$t('moodPulse.modal.created')))
                .catch(() => danger())
                .finally(() => {
                    this.refreshItems()
                    this.localShow = false

                    this.daysSelected = []

                    this.form = {
                        question: null,
                        sunday: false,
                        monday: false,
                        tuesday: false,
                        wednesday: false,
                        thursday: false,
                        friday: false,
                        saturday: false,
                        can_anonymous: false,
                        can_comment: false,
                        must_comment: false,
                        quiz_email_frequency_id: 1,
                        start_now: false,
                        sections: [],
                    }
                })
        },
        updateNew(form) {
            form.quiz_status_id = this.itemToEdit.quiz_status.id
            updateQuiz(this.itemToEdit.id, form)
                .then(() => success(this.$t('moodPulse.modal.updated')))
                .catch(() => danger())
                .finally(() => {
                    this.refreshItems()
                    this.localShow = false

                    this.daysSelected = []

                    console.log(this.form.question)

                    this.form = {
                        question: null,
                        sunday: false,
                        monday: false,
                        tuesday: false,
                        wednesday: false,
                        thursday: false,
                        friday: false,
                        saturday: false,
                        can_anonymous: false,
                        can_comment: false,
                        must_comment: false,
                        quiz_email_frequency_id: 1,
                        start_now: false,
                        sections: [],
                    }
                })
        },
    },
}
</script>

<style scoped>
.title {
    font-family: Roboto;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 28px;
    color: #022b4f;
}

.label-text {
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    color: #808080;
}

.close {
    width: 14px;
    height: 14px;
    cursor: pointer;
}

.placeholder-text {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    color: #808080;
}
</style>
